import React, { Component } from 'react'
import { connect } from 'react-redux'
import { RestrictedArea } from './RestrictedArea.container'
import { identity } from './../../jsCore/utils/fn'
import { get as getFromPdo } from './../../jsCore/application/pageDataObject'
import { AdminActionsList } from './AdminActionsList.view'
import * as mapDispatchToProps from './../../jsCore/store/adminActions/adminActions.actions'

const redirect = url => window.location.assign(url)

const ADMIN_SECTION = 'admin'
const BLOCK_NAME = 'admin-panel'

class AdminPanelContainerComponent extends Component {
  constructor() {
    super()
    this.state = { userId: getFromPdo('page.user_id') }
  }

  impersonate = () => this.props.impersonate(this.state.userId)
  showInAdmin = () => redirect(`/${ADMIN_SECTION}/users/${this.state.userId}`)
  makeAdmin = () => redirect(`/${ADMIN_SECTION}/make_admin_user?id=${this.state.userId}`)
  unAdmin = () => redirect(`/${ADMIN_SECTION}/unadmin_user?id=${this.state.userId}`)
  lastWeek = () =>
    redirect(`/${ADMIN_SECTION}/users/${this.state.userId}/weekly_summary?week=last_week`)
  liveWeek = () => redirect(`/${ADMIN_SECTION}/users/${this.state.userId}/weekly_summary`)

  getAdminActions = () => [
    { name: 'impersonate', onClick: this.impersonate },
    { name: 'show in admin panel', onClick: this.showInAdmin },
    { name: 'make admin', onClick: this.makeAdmin },
    { name: 'unadmin', onClick: this.unAdmin },
  ]

  getWeeklySummaries = () => [
    { name: 'last week', onClick: this.lastWeek },
    { name: 'live week', onClick: this.liveWeek },
  ]

  render() {
    return (
      <RestrictedArea>
        <section className={BLOCK_NAME}>
          <h2 className={`${BLOCK_NAME}__title`}>admin actions</h2>

          <div className={`${BLOCK_NAME}__actions`}>
            <AdminActionsList actions={this.getAdminActions()} />

            <h4 className={`${BLOCK_NAME}__sub-title`}>weekly summaries</h4>
            <AdminActionsList actions={this.getWeeklySummaries()} />
          </div>
        </section>
      </RestrictedArea>
    )
  }
}

export const AdminPanelContainer = ({ name, stateKey }) => ({
  name,
  stateKey,
  component: connect(identity, mapDispatchToProps)(AdminPanelContainerComponent),
})



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/admin_panel/AdminPanel.container.js